import React from 'react';
import {connect} from 'react-redux';
import {AppState} from '@Redux/store';

import { ArsenalUnit } from '@Models';
import { shareArsenalUnitSelector } from '@Selectors/arsenal/share/share-arsenal-unit.selector';
import Repeater from '@Utils/Repeater';

export interface IArsenalArmyUnitExportProps {
  unit: ArsenalUnit,
}

const ArsenalArmyUnitExportComponent: React.FC<ArmyListUnitExportProps> = ({ unit }) => {

  return (
    <tr>
      <td>{unit.name}</td>
      <Repeater data={unit.steps} indexPrefix='steps'>
        {
          (item: string) => <td>{item}</td>
        }
      </Repeater>
    </tr>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArsenalArmyUnitExportProps) => ({
  unit: shareArsenalUnitSelector(state, owsProps),
})

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalArmyUnitExportComponent);

type ArmyListUnitExportProps = ReturnType<typeof mapDispatchToProps> &
                          ReturnType<typeof mapStateToProps>